import { FunctionalComponent, h } from '@stencil/core';
import { AppTestimonial } from '.';

interface SectionTestimonials {
  __component: string;
  data?: any;
}


export const SectionTestimonials: FunctionalComponent<SectionTestimonials> = ({data}) => {

  const { Autoplay, Infinite, Subtitle, Title, TestimonialCards} = data;

  return (
    <section class="uk-section uk-position-relative uk-background-muted uk-container uk-container-xlarge">
      <div class="uk-container uk-position-relative">
        <div class="uk-padding uk-padding-remove-left uk-padding-remove-top">
          <h2 class="uk-heading-small wsio-gold uk-margin-small-bottom">{Subtitle}</h2>
          <h3 class="uk-heading-xlarge wsio-darker-green uk-width-1-1 uk-margin-remove">{Title}</h3>
        </div>
        <div class="uk-margin">
          <div class="uk-width-1-1">
            <div uk-slider={`finite: ${!Infinite}; ${Autoplay ? 'autoplay: true;"' : ''}`} >
              <div class="uk-position-relative">
                <ul class="uk-slider-items uk-grid uk-grid-match">
                  {TestimonialCards.map(({ JobTitle, Image, Name, Quote }, i) => <AppTestimonial Index={i} JobTitle={JobTitle} Image={Image} Name={Name} Quote={Quote} />)}
                </ul>
              </div>
              <div class="uk-margin-medium-top uk-flex uk-flex-right">
                <a
                  href="#" rel="nofollow" 
                  uk-slidenav-previous
                  uk-slider-item="previous"
                  aria-label="previous"
                ></a>
                <span class="uk-margin-right"></span>
                <a
                  href="#" rel="nofollow" 
                  uk-slidenav-next
                  uk-slider-item="next"
                  aria-label="next"
                ></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )

};